<template>
    <div class="c-sign-up-buttons">
        <router-link
            v-if="displayTeacher && country !== 'USA'"
            :to="{ name: 'auth.register', query: { role: 'teacher' } }"
        >
            <MathButton class="math-button--teacher">
                <img
                    src="/images/lp/icon-teacher.svg"
                    :alt="$t('auth.registration.roleTeacher')"
                />
                {{
                    teacherRoleText
                        ? teacherRoleText
                        : $t('auth.registration.roleTeacher')
                }}
            </MathButton>
        </router-link>
        <router-link
            v-if="displayTeacher && country === 'USA'"
            :to="{ name: 'teacher-register' }"
        >
            <MathButton class="math-button--teacher">
                <img
                    src="/images/lp/icon-teacher.svg"
                    :alt="$t('auth.registration.roleTeacher')"
                />
                {{
                    teacherRoleText
                        ? teacherRoleText
                        : $t('auth.registration.roleTeacher')
                }}
            </MathButton>
        </router-link>
        <router-link
            v-if="displayStudent"
            :to="{ name: 'auth.register', query: { role: 'student' } }"
        >
            <MathButton class="math-button--student">
                <img
                    src="/images/lp/icon-student.svg"
                    :alt="$t('auth.registration.roleStudent')"
                />
                {{
                    studentRoleText
                        ? studentRoleText
                        : $t('auth.registration.roleStudent')
                }}
            </MathButton>
        </router-link>
        <router-link
            v-if="displayParent"
            :to="{ name: 'auth.register', query: { role: 'parent' } }"
        >
            <MathButton class="math-button--parent">
                <img
                    src="/images/lp/icon-parent.svg"
                    :alt="$t('auth.registration.roleParent')"
                />
                {{
                    parentRoleText
                        ? parentRoleText
                        : $t('auth.registration.roleParent')
                }}
            </MathButton>
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MathButton from '@/core/ui/_legacy/MathComponents/MathButton.vue';
export default {
    components: { MathButton },
    props: {
        displayTeacher: {
            type: Boolean,
            default: true,
        },
        displayStudent: {
            type: Boolean,
            default: true,
        },
        displayParent: {
            type: Boolean,
            default: true,
        },
        teacherRoleText: {
            type: String,
        },
        studentRoleText: {
            type: String,
        },
        parentRoleText: {
            type: String,
        },
    },
    computed: {
        ...mapGetters({
            currentLanguage: 'getCurrentLanguage',
            country: 'getCountry',
        }),
    },
};
</script>

<style scoped lang="scss">
.c-sign-up-buttons {
    display: flex;
    flex-direction: column;
    width: 100%;

    @include mq($w-min-desktop, min) {
        flex-direction: row;
        justify-content: center;
    }

    a:hover,
    a:focus {
        text-decoration: none;
    }

    .math-button {
        margin-bottom: 1rem;
        width: 100%;
        padding: 0 1rem;

        @include mq($w-min-desktop, min) {
            margin-right: 1rem;
            width: initial;
            padding: 0 2rem;
        }

        img {
            margin-top: -5px;
            padding-right: 0.5rem;
            max-height: 30px;
        }

        &--student {
            img {
                padding-right: 0.5rem;
            }
        }
    }
}
</style>
